
import { useState } from 'react';

const useModal = () => {
  const [isShowing, setIsShowing] = useState(false);
  const [isNewShowing, setIsNewShowing] = useState(false);
  const [isMultipleAudioShowing, setIsMultipleAudioShowing] = useState(false);

  function toggle() {
    setIsShowing(!isShowing);
  }
  function newToggle() {
      setIsNewShowing(!isNewShowing);
  }

  function multipleAudioToggle() {
    setIsMultipleAudioShowing(!isMultipleAudioShowing);
  }

  return {
    isShowing,
    isNewShowing,
    isMultipleAudioShowing,
    toggle,
    newToggle,
    multipleAudioToggle
  }
};

export default useModal;


// WEBPACK FOOTER //
// ./web/components/campaign/useModel.js